import React from 'react'
import MainHeader from "./partials/newheader";    
import Footer from "./partials/footer";
import Dining from "../pettiPettiMirissa/dining";

export default function Pettipettidine() {
  return (
    <div>
      <MainHeader />
      <Dining />
      <Footer />
    </div>
  );
}
